import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PCGState } from './pcg.reducer';
import * as fromPCG from './pcg.reducer';
import { LoadingState, getError } from 'app/utils/callstate';

export const selectPCGState = createFeatureSelector<PCGState>('pcg');

export const selectPCG = createSelector(
  selectPCGState,
  fromPCG.selectAll
);

export const selectPCGLoading = createSelector(
  selectPCGState,
  pcgState => pcgState.callState === LoadingState.Loading
);

export const selectPCGLoaded = createSelector(
  selectPCGState,
  pcgState => pcgState.callState === LoadingState.Loaded
);

export const selectPCGError = createSelector(
  selectPCGState,
  pcgState => getError(pcgState.callState)
);
